import * as React from 'react';
import { EGDSSpacing } from '@egds/react-core/spacing';
import { SharedUiPropertyLevelOffersMessageWrapper } from 'components/infosite/shared-ui/offers/property-level-messages-wrapper';
export const PropertyLevelMessages = () => React.createElement(EGDSSpacing, {
  margin: {
    small: {
      blockend: 'six'
    }
  }
}, React.createElement("div", null, React.createElement(SharedUiPropertyLevelOffersMessageWrapper, null)));